import { ApiError } from '@/services/api';

const MAX_QUERY_RETRIES = 3;
/** Matches useFeed / team-profile hooks: up to 2 retries (3 attempts) for transient errors. */
const MAX_NOT_FOUND_QUERY_RETRIES = 2;

/** Default query `retry`: a 403 is a final answer, so show it at once; anything else keeps react-query's 3 retries. */
export function retryUnlessForbidden(
  failureCount: number,
  error: unknown,
): boolean {
  const forbidden = error instanceof ApiError && error.status === 403;
  return !forbidden && failureCount < MAX_QUERY_RETRIES;
}

/** A 404 is a final answer — don't retry. Other errors retry a couple of times. */
export function retryUnlessNotFound(
  failureCount: number,
  error: unknown,
): boolean {
  const notFound = error instanceof ApiError && error.status === 404;
  return !notFound && failureCount < MAX_NOT_FOUND_QUERY_RETRIES;
}
